import { Box, useTheme } from '@mui/material';
import React, { Suspense } from 'react';

import Header from '../../components/Header';
import { tokens } from '../../theme';

const LazyGeographyChart = React.lazy(() =>
  import('../../components/GeographyChart'),
);

const Geography = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box m="20px">
      <Header title="Geography" subtitle="Simple Geography Chart" />

      <Box
        height="75vh"
        border={`1px solid ${colors.grey[100]}`}
        borderRadius="4px"
      >
        <Suspense fallback={<div>Loading...</div>}>
          <LazyGeographyChart />
        </Suspense>
      </Box>
    </Box>
  );
};

export default Geography;
